// Polyfill per SockJS - DEVE essere il primo a caricarsi
(window as any).global = window;
(globalThis as any).global = globalThis;
